import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import classNames from 'classnames';
import { kebabCase } from 'lodash-es';
import { forwardRef } from 'react';
const labelCss = "l1njjb93";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const defaultStateCss = "d1o63cd9";
const DefaultState = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(defaultStateCss, props.className)} />;
});
const selectedStateCss = "s181afs";
const SelectedState = forwardRef((props, ref) => <DefaultState ref={ref} {...props} className={classNames(selectedStateCss, props.className)} />);
const disabledStateCss = "d10cxv64";
const DisabledState = forwardRef((props, ref) => <DefaultState ref={ref} {...props} className={classNames(disabledStateCss, props.className)} />);
const optionsContainerCss = "ong4kq";
export const OptionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionsContainerCss, props.className)} />;
});
export const Option = ({
  item,
  onClick = () => {},
  disabled = false,
  selected = false,
  formatter = ({
    name
  }) => name
}) => {
  let Component = DefaultState;
  if (disabled) {
    Component = DisabledState;
  }
  if (selected) {
    Component = SelectedState;
  }
  return <>
      <Component />
      <Label>
        <CheckboxInput name={kebabCase(item.name)} onChange={() => onClick(item)} onKeyPress={({
        key
      }) => {
        if (key === 'Enter') {
          onClick(item);
        }
      }} checked={selected} disabled={disabled} />
        {formatter(item)}
      </Label>
    </>;
};

require("./option.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option.js");